// src/contexts/SignalRContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import SignalRService from "../services/signalRService";
import appConfig from "../envConfig/config";
import { authenticationService } from "../services/authentication.service";

const SignalRContext = createContext();

export const SignalRProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatHub, setChatHub] = useState(null);
  const [calendarHub, setCalendarHub] = useState(null);

  useEffect(() => {
    if (!authenticationService.currentUserToken) return;

    const services = [];

    // ChatHub (optional)
    if (appConfig.chatHubUrl) {
      const chatService = SignalRService.getInstance(appConfig.chatHubUrl);
      chatService.startConnection().then(() => {
        chatService.on("MessageReceived", (msg) => {
          setChatMessages((prev) => [...prev, msg]);
        });
        chatService.on("userjoined", (user) => {
          console.log("User joined:", user);
        });
      });
      setChatHub(chatService);
      services.push({ service: chatService, off: ["MessageReceived" ]});
    } else {
      console.warn("SignalR chatHubUrl is not configured; skipping chat connection.");
    }

    // CalendarHub (optional)
    if (appConfig.calHubUrl || appConfig.hub_url) {
      const url = appConfig.calHubUrl || appConfig.hub_url; // support legacy key
      const calendarService = SignalRService.getInstance(url);
      calendarService.startConnection().then(() => {
        calendarService.on("NotificationReceived", (notification) => {
          setNotifications((prev) => [...prev, notification]);
        });
      });
      setCalendarHub(calendarService);
      services.push({ service: calendarService, off: ["NotificationReceived"]});
    } else {
      console.warn("SignalR calHubUrl/hub_url is not configured; skipping calendar connection.");
    }

    return () => {
      services.forEach(({ service, off }) => {
        off.forEach((evt) => service.off(evt));
        service.stopConnection();
      });
    };
  }, []);

 const joinChat = async (chatId) => {
    if (!chatHub) return;
    try {
      await chatHub.invoke("JoinChat", chatId);
      console.log("✅ Joined chat:", chatId);
    } catch (err) {
      console.error("❌ Error joining chat:", err);
    }
  };

  const leaveChat = async (chatId) => {
    if (!chatHub) return;
    try {
      await chatHub.invoke("LeaveChat", chatId);
      console.log("👋 Left chat:", chatId);
    } catch (err) {
      console.error("❌ Error leaving chat:", err);
    }
  };

  return (
    <SignalRContext.Provider value={{ notifications, chatMessages,joinChat,leaveChat }}>
      {children}
    </SignalRContext.Provider>
  );
};

// Custom hook to consume the context
export const useSignalR = () => useContext(SignalRContext);
